var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPropertyHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94929 1.42773L7.40711 1.80017H7.42002V1.81067L12.7 6.10601V11.3683H23.7V26.4501H11.8V26.45H0.800049V6.09669L6.94929 1.42773ZM11.8 25.55V11.3683V6.53405L7.42002 2.97087V25.55H11.8ZM12.7 25.5501H22.8V12.2683H12.7V25.5501ZM1.70005 6.54337L6.52002 2.8837V25.55H1.70005V6.54337ZM8.05005 9.8364V8.9364H10.45V9.8364H8.05005ZM3.05005 8.9364V9.8364H5.45005V8.9364H3.05005ZM8.05005 14.2V13.3H10.45V14.2H8.05005ZM8.05005 17.6637V18.5637H10.45V17.6637H8.05005ZM8.05005 22.9273V22.0273H10.45V22.9273H8.05005ZM3.05005 13.3V14.2H5.45005V13.3H3.05005ZM3.05005 18.5637V17.6637H5.45005V18.5637H3.05005ZM3.05005 22.0273V22.9273H5.45005V22.0273H3.05005ZM14.05 13.8H14.95V17.4728H14.05L14.05 13.8ZM17.95 13.8H17.05V17.4728H17.95V13.8ZM20.05 13.8H20.95V17.4728H20.05V13.8ZM14.95 19.2546H14.05L14.05 22.9274H14.95V19.2546ZM17.05 19.2546H17.95V22.9274H17.05V19.2546ZM20.95 19.2546H20.05V22.9274H20.95V19.2546Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPropertyHover);
export default __webpack_public_path__ + "static/media/my-property-hover.8607faca.svg";
export { ForwardRef as ReactComponent };